import { SITE_RECAPTCHA_KEY } from '../../environments/environment';
import { CustomerDataUI, RequestValidateCustomerData } from '../interfaces/customer-data.interface';
import {
	GenerateSendOtpUI,
	ResponseGenerateSendOtp,
} from '../interfaces/generate-send-otp.interface';
import {
	InitialParametersModel,
	ResponseInitialParameters,
} from '../interfaces/initial-parameters.interface';
import { OtpValidationUI, ResponseOtpValidation } from '../interfaces/otp-validation.interface';
import { SIMULATOR_BY_TYPE } from './constants';

export const mapper: {
	initialParameters: (resp: ResponseInitialParameters) => InitialParametersModel;
	requestValidateData: (form: CustomerDataUI, recaptcha: string) => RequestValidateCustomerData;
	otpGenerated: (resp: ResponseGenerateSendOtp) => GenerateSendOtpUI;
	otpValidation: (resp: ResponseOtpValidation) => OtpValidationUI;
} = {
	initialParameters: resp => ({
		title: resp.titulo,
		subtitle: resp.subTitulo,
		content: resp.contenido,
		surveyBanner: resp.encuesta,
		nameLeakSurvey: resp.encuestaFuga,
		idFeedbackSurvey: resp.idEncuestaFeedback,
		idLeakSurvey: resp.idEncuestaFuga,
		simulatorType: resp.tipoSimulador,
		simulatorUrl: SIMULATOR_BY_TYPE[resp.simulador as keyof typeof SIMULATOR_BY_TYPE] ?? null,
		salesLevels: resp.nivelVentas.map((item: { rango: string; nivel: string }) => ({
			range: item.rango,
			level: item.nivel,
		})),
	}),
	requestValidateData: (form, recaptcha) => ({
		captchaUserVerify: recaptcha,
		publicKey: SITE_RECAPTCHA_KEY,
		rutCliente: form.companyRut,
		rutUsuario: form.userRut ?? form.companyRut,
		correo: form.email,
		telefono: form.phoneNumber,
		nivelVenta: form.salesLevel,
	}),
	otpGenerated: resp => ({
		secondsExpirationOtp: resp.vencimientoOtpSeg,
		otpGenerationTime: resp.horaGeneracionOtp,
		hiddenTarget: resp.destinoOfuscado,
	}),
	otpValidation: resp => ({
		otpValid: resp.valido,
		attempts: resp.intentosRestantes,
	}),
};
